
import { useContext } from '@nuxtjs/composition-api';
import useUtilities from '@/composable/useUtilities';
import useTlmCart from '@/composable/useTlmCart';
import useProductType from '~/composable/useProductType';
export default {
  props: {
    summary: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { app } = useContext()
    const { getSubscriptionName } = useUtilities()
    const { cart, isPayGSubscription } = useTlmCart(app)
    const { isSubscription, isMobileBroadBandSubscription } = useProductType()
    return {
      isPayGSubscription,
      isMobileBroadBandSubscription,
      getSubscriptionName,
      cart,
      isSubscription
    }
  }
}
